import { API_BASE_URL } from '../../config/api';
import React, { useState, useEffect } from 'react'
import axios from 'axios';
import PopupCart from '../component/PopupCart';
import Viewimage from './Component/Viewimage';
import { useTranslation } from 'react-i18next';
import SEO from '../component/SEO';

const Freelanch = () => {
  const [products, setProducts] = useState([]);
  const { t, i18n } = useTranslation();

  useEffect(() => {
    axios
      .get(`${API_BASE_URL}/freelanch/meniu/`, {
        headers: {
          'Accept-Language': i18n.language
        },
      })
      .then(response => {
        setProducts(response.data);
      })
      .catch(error => {
        console.error(t('common.errorFetchingProducts'), error);
      });
  }, [i18n.language, t]);

  return (
    <div className="test_block">
        <SEO />
        <div className="container">
          <div className="row">
            <div className="col-lg-12 col-md-12">
              <h3 className="main-content__main-products desktop-title tac">{t('freelanch.title')}</h3>
              <div className="desktop-content">
                  <p>{t('freelanch.description1')}</p>     
                  <p>{t('freelanch.description2')}</p>   
              </div>
              <h3 className="main-content__main-products desktop-title tac">{t('freelanch.donateTitle')}</h3>
            </div>
          </div>
          
          <div className="products-cards-grid">
            {Array.isArray(products) && products.length > 0 && products.map(product => (
              <div key={product.id} className="main-content__product product-box">
                <div style={{ display: 'flex', flexDirection: 'column', flexGrow: 1 }}>
                  <div className="main-content__product__image" itemProp="image">
                    <img src={product.image} alt={product.title} />
                  </div>
                  <p className="main-content__product__name" itemProp="name">{product.title}</p>
                  <p className="main-content__product__description">{product.detail}</p>
                </div>
                <div className="main-content__product__to-cart-box" itemProp="offers">
                  <span className="main-content__product__price">
                    <span className="product-total-amount" itemProp="price">{product.count}</span> 
                    <span> {t('freelanch.currency')}</span>
                  </span>
                  <PopupCart title={product.title} count={product.count} />
                </div>
              </div>
            ))}
          </div>

          <h3 className="main-content__main-products desktop-title tac">{t('freelanch.ourMeals')}</h3>
          <Viewimage />
        </div>
      </div>
  )
}

export default Freelanch
